import axios from "./axiosInstance";

export const fetchManagedUsers = async (token) => {
  const res = await axios.get("/api/Admin/managed-users", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const resetUserPassword = async (token, { userId, newPassword }) => {
  const res = await axios.put(
    `/api/User/admin-reset-password/${userId}`,
    { newPassword }, // 注意這邊只送密碼進 body
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json", // 明確指定 content-type
      },
    }
  );
  return res.data;
};

export const registerUser = async (token, form) => {
  const res = await axios.post("/api/Admin/register", form, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};
